/* © CNES */
import { useContext, useMemo } from 'react';
import {
  filterSections,
  Missions,
  refMissions,
} from '../../../../../assets/config/filters/Referenciel';
import { FilterDataContext } from '../../../../../context/FilterDataContext';
import { SelectButtonItem } from '../../../../../models/SelectButtonItem';
import { CustomAccordion } from '../../../../shared/Accordion/CustomAccordion';
import { DATASET } from '../../../../shared/Constants';
import { FilterSelectButtons } from '../FilterSelectButtons/FilterSelectButtons';

/**
 * Variable Condition Props.
 */
export interface VariableConditionProps {
  variableOptions: SelectButtonItem[] | null;
  handleChange: (e: any, key: string) => void;
}

/**
 * Variable Condition to display other filters depending on product type selection.
 * @param productTypeOptions all variable for selected Missions / product type.
 * @param handleChange Function to handle change on variableselection.
 * @returns productTypeCondition Element.
 */
export const VariableCondition = ({
  handleChange,
  variableOptions,
}: VariableConditionProps) => {
  const { filterData } = useContext(FilterDataContext);
  /**
   * set new values of variable button select
   * @param value The variable to handle.
   */
  const onChangeVariable = (value: string | number[]) => {
    handleChange(value, filterSections.variable.param);
  };

  const variableOptionList: SelectButtonItem[] | null = useMemo(() => {
    const refMission = refMissions.find((refMission) => {
      return (
        JSON.stringify(refMission.key) === JSON.stringify(filterData[DATASET])
      );
    });
    if (refMission?.value === Missions.GEOV2_AVHRR) {
      return (
        variableOptions?.filter((el) => el.key !== 'SurfaceReflectance') || null
      );
    }
    return variableOptions;
  }, [filterData, variableOptions]);

  return (
    <div className="variableFilter">
      <CustomAccordion
        title={filterSections.variable.title}
        children={
          variableOptionList && variableOptionList.length > 0 ? (
            <FilterSelectButtons
              name={filterSections.variable.param}
              options={variableOptionList}
              handleChange={onChangeVariable}
            />
          ) : (
            <div>Please select a type of product first.</div>
          )
        }
      />
    </div>
  );
};
